import React, {
  useEffect,
} from 'react';
import {
  useHistory,
} from 'react-router';
import {
  useObserver,
} from 'mobx-react';
import {
  RequestStatus,
  stores,
} from '../../mobx-store';
import GeneralTableComponent from '../../components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import {
  TableCellTypes,
} from '../../components/GeneralCRUDComponent/TableCellTypes/TableCellTypes';
import {
  languageCodes,
} from '../../constants/languages';
import {
  translate,
} from '../../helperFunctions/translation';
import {
  BranchFeatureDTO,
} from './DTOs/branchFeatureDTO';

const BranchFeatureTableScreen: React.FC = () => {
  const history = useHistory();

  useEffect(() => {
    (async () => stores.branchFeatureStore.getBranchFeaturesList(languageCodes.english))();
  }, []);

  const tableHeaders = [
    {
      title: 'Title',
    },
    {
      title: '',
    },
  ];

  const handleEditButtonClicked = (index: number) => {
    history.push(`/branch-features/${stores.branchFeatureStore.BranchFeaturesList[index].branchFeatureId}/edit`);
  };

  const cellTypes: TableCellTypes[] = [
    {
      cellType: 'Text',
      key: 'title',
    },
    {
      cellType: 'Button',
      key: 'edit',
      onClick: handleEditButtonClicked,
    },
  ];

  const getTableData = () => stores.branchFeatureStore.BranchFeaturesList.map(
    (branchFeature: BranchFeatureDTO) => ({
      title: branchFeature.title,
      edit: translate('editButton', {
      }),
    }),
  );

  const createAddButton = () => ({
    title: translate('addButton', {
    }),
    onAdd: (): void => {
      history.push('/branch-features/new');
    },
  });

  return useObserver(
    () => (
      <GeneralTableComponent
        title={translate('branchFeatureTableTitle', {
        })}
        emptyMessage={translate('branchFeatureEmptyTableMessage', {
        })}
        tableHeader={tableHeaders}
        tableData={getTableData()}
        tableCellTypes={cellTypes}
        addButton={createAddButton()}
        loading={stores.branchFeatureStore.CRUDStatus === RequestStatus.LOADING}
        loadingStatus={[
          stores.branchFeatureStore.CRUDStatus,
        ]}
      />
    ),
  );
};

export default BranchFeatureTableScreen;
